import React from 'react'

interface AuthCardProps {
  title: string
  subtitle?: string
  icon?: React.ReactNode
  children: React.ReactNode
}

export function AuthCard({ title, subtitle, icon, children }: AuthCardProps) {
  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center px-4 relative overflow-hidden" data-testid="auth-card-container">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-gradient-to-br from-brand-primary/10 via-transparent to-brand-blue/5" />
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-primary/50 to-transparent" />
      </div>

      <div className="max-w-md w-full space-y-8 relative z-10 animate-fade-in-up">
        {/* Monumenta Logo */}
        <div className="text-center">
          <h1 className="font-display text-4xl font-bold text-brand-primary mb-2 bg-gradient-to-r from-brand-primary to-brand-accent-600 bg-clip-text text-transparent">
            Monumenta
          </h1>
          <h2 className="font-display text-xl text-white mb-2 bg-gradient-to-r from-white to-brand-gray-light bg-clip-text text-transparent">
            Sistema de Gestão Monumenta
          </h2>
          <p className="text-brand-gray font-body text-sm">
            Orgulhosamente independente desde 1995
          </p>
        </div>

        {/* Auth Card */}
        <div className="card" data-testid="auth-card">
          {/* Header */}
          <div className="text-center mb-8" data-testid="auth-card-header">
            {icon && (
              <div className="w-16 h-16 mx-auto mb-4 bg-gradient-to-br from-brand-primary to-brand-accent-600 rounded-monumenta flex items-center justify-center shadow-monumenta-brand" data-testid="auth-card-icon">
                {icon}
              </div>
            )}
            <h1 className="text-2xl font-display font-bold text-white mb-2" data-testid="auth-card-title">
              {title}
            </h1>
            {subtitle && (
              <p className="text-brand-gray text-sm font-body" data-testid="auth-card-subtitle">
                {subtitle}
              </p>
            )}
          </div>

          {/* Content */}
          <div data-testid="auth-card-content">
            {children}
          </div>
        </div>

        {/* Footer */}
        <div className="text-center text-xs text-brand-gray font-body">
          <p>© 2025 Monumenta Comunicação e Estratégias Sociais</p>
          <p className="mt-1">Desenvolvido com ❤️ pela DevSquad</p>
        </div>
      </div>
    </div>
  )
}